import { pick } from 'lodash';
import type { PostTestInstanceResponseMarker } from './types';

function preparePostRelationships(
  testInstanceResponseMarker: PostTestInstanceResponseMarker
): MutationBodyRelationships {
  return {
    ...(testInstanceResponseMarker.testInstanceResponseId
      ? {
          testInstanceResponse: {
            data: {
              id: `/api/v2/test-instance-responses/${testInstanceResponseMarker.testInstanceResponseId}`,
              type: 'TestInstanceResponse'
            }
          }
        }
      : {}),
    ...(testInstanceResponseMarker.customerUserId
      ? {
          user: {
            data: {
              id: `/api/v2/customers-users/${testInstanceResponseMarker.customerUserId}`,
              type: 'User'
            }
          }
        }
      : {})
  };
}

export function preparePostTestInstanceResponseMarker(
  testInstanceResponseMarker: PostTestInstanceResponseMarker
): PostMutationBody {
  return {
    data: {
      type: 'TestInstanceResponseMarker',
      attributes: {
        ...pick(testInstanceResponseMarker, [])
      },
      relationships: preparePostRelationships(testInstanceResponseMarker)
    }
  };
}
